// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LOS DICCIONARIOS DE CADA IDIOMA, UNO POR ZONA (B-2259) — GENERADO, NO SE EDITA A MANO
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  Lo escribe  node herramientas/i18n/traducir.js --indice  (y cada traducción). Un import() perezoso por fichero: Vite
//  hace un trozo de cada uno y solo se baja el que se pide (utils/i18nCargar). Sin import.meta, para que las guardias
//  puedan cargar de verdad el cargador. La guardia backend/services/i18n-castellano-igual.test.js lo compara con shared/i18n.
export const DICCIONARIOS = {
  'ca/agenda': () => import('../../../shared/i18n/ca/agenda.json'),
  'ca/ajustes': () => import('../../../shared/i18n/ca/ajustes.json'),
  'ca/almacen': () => import('../../../shared/i18n/ca/almacen.json'),
  'ca/catalogos': () => import('../../../shared/i18n/ca/catalogos.json'),
  'ca/clinica': () => import('../../../shared/i18n/ca/clinica.json'),
  'ca/comun': () => import('../../../shared/i18n/ca/comun.json'),
  'ca/comunicacion': () => import('../../../shared/i18n/ca/comunicacion.json'),
  'ca/cuenta': () => import('../../../shared/i18n/ca/cuenta.json'),
  'ca/dinero': () => import('../../../shared/i18n/ca/dinero.json'),
  'ca/equipo': () => import('../../../shared/i18n/ca/equipo.json'),
  'ca/informes': () => import('../../../shared/i18n/ca/informes.json'),
  'ca/inicio': () => import('../../../shared/i18n/ca/inicio.json'),
  'ca/mantenimiento': () => import('../../../shared/i18n/ca/mantenimiento.json'),
  'ca/migracion': () => import('../../../shared/i18n/ca/migracion.json'),
  'ca/nube': () => import('../../../shared/i18n/ca/nube.json'),
  'ca/paciente': () => import('../../../shared/i18n/ca/paciente.json'),
  'ca/personal': () => import('../../../shared/i18n/ca/personal.json'),
  'ca/recepcion': () => import('../../../shared/i18n/ca/recepcion.json'),
  'ca/sala': () => import('../../../shared/i18n/ca/sala.json'),
  'ca/superadmin': () => import('../../../shared/i18n/ca/superadmin.json'),
  'ca/vocabulario': () => import('../../../shared/i18n/ca/vocabulario.json'),
  'de/agenda': () => import('../../../shared/i18n/de/agenda.json'),
  'de/ajustes': () => import('../../../shared/i18n/de/ajustes.json'),
  'de/almacen': () => import('../../../shared/i18n/de/almacen.json'),
  'de/catalogos': () => import('../../../shared/i18n/de/catalogos.json'),
  'de/clinica': () => import('../../../shared/i18n/de/clinica.json'),
  'de/comun': () => import('../../../shared/i18n/de/comun.json'),
  'de/comunicacion': () => import('../../../shared/i18n/de/comunicacion.json'),
  'de/cuenta': () => import('../../../shared/i18n/de/cuenta.json'),
  'de/dinero': () => import('../../../shared/i18n/de/dinero.json'),
  'de/equipo': () => import('../../../shared/i18n/de/equipo.json'),
  'de/informes': () => import('../../../shared/i18n/de/informes.json'),
  'de/inicio': () => import('../../../shared/i18n/de/inicio.json'),
  'de/mantenimiento': () => import('../../../shared/i18n/de/mantenimiento.json'),
  'de/migracion': () => import('../../../shared/i18n/de/migracion.json'),
  'de/nube': () => import('../../../shared/i18n/de/nube.json'),
  'de/paciente': () => import('../../../shared/i18n/de/paciente.json'),
  'de/personal': () => import('../../../shared/i18n/de/personal.json'),
  'de/recepcion': () => import('../../../shared/i18n/de/recepcion.json'),
  'de/sala': () => import('../../../shared/i18n/de/sala.json'),
  'de/superadmin': () => import('../../../shared/i18n/de/superadmin.json'),
  'de/vocabulario': () => import('../../../shared/i18n/de/vocabulario.json'),
  'en/agenda': () => import('../../../shared/i18n/en/agenda.json'),
  'en/ajustes': () => import('../../../shared/i18n/en/ajustes.json'),
  'en/almacen': () => import('../../../shared/i18n/en/almacen.json'),
  'en/catalogos': () => import('../../../shared/i18n/en/catalogos.json'),
  'en/clinica': () => import('../../../shared/i18n/en/clinica.json'),
  'en/comun': () => import('../../../shared/i18n/en/comun.json'),
  'en/comunicacion': () => import('../../../shared/i18n/en/comunicacion.json'),
  'en/cuenta': () => import('../../../shared/i18n/en/cuenta.json'),
  'en/dinero': () => import('../../../shared/i18n/en/dinero.json'),
  'en/equipo': () => import('../../../shared/i18n/en/equipo.json'),
  'en/informes': () => import('../../../shared/i18n/en/informes.json'),
  'en/inicio': () => import('../../../shared/i18n/en/inicio.json'),
  'en/mantenimiento': () => import('../../../shared/i18n/en/mantenimiento.json'),
  'en/migracion': () => import('../../../shared/i18n/en/migracion.json'),
  'en/nube': () => import('../../../shared/i18n/en/nube.json'),
  'en/paciente': () => import('../../../shared/i18n/en/paciente.json'),
  'en/personal': () => import('../../../shared/i18n/en/personal.json'),
  'en/recepcion': () => import('../../../shared/i18n/en/recepcion.json'),
  'en/sala': () => import('../../../shared/i18n/en/sala.json'),
  'en/superadmin': () => import('../../../shared/i18n/en/superadmin.json'),
  'en/vocabulario': () => import('../../../shared/i18n/en/vocabulario.json'),
  'eu/agenda': () => import('../../../shared/i18n/eu/agenda.json'),
  'eu/ajustes': () => import('../../../shared/i18n/eu/ajustes.json'),
  'eu/almacen': () => import('../../../shared/i18n/eu/almacen.json'),
  'eu/catalogos': () => import('../../../shared/i18n/eu/catalogos.json'),
  'eu/clinica': () => import('../../../shared/i18n/eu/clinica.json'),
  'eu/comun': () => import('../../../shared/i18n/eu/comun.json'),
  'eu/comunicacion': () => import('../../../shared/i18n/eu/comunicacion.json'),
  'eu/cuenta': () => import('../../../shared/i18n/eu/cuenta.json'),
  'eu/dinero': () => import('../../../shared/i18n/eu/dinero.json'),
  'eu/equipo': () => import('../../../shared/i18n/eu/equipo.json'),
  'eu/informes': () => import('../../../shared/i18n/eu/informes.json'),
  'eu/inicio': () => import('../../../shared/i18n/eu/inicio.json'),
  'eu/mantenimiento': () => import('../../../shared/i18n/eu/mantenimiento.json'),
  'eu/migracion': () => import('../../../shared/i18n/eu/migracion.json'),
  'eu/nube': () => import('../../../shared/i18n/eu/nube.json'),
  'eu/paciente': () => import('../../../shared/i18n/eu/paciente.json'),
  'eu/personal': () => import('../../../shared/i18n/eu/personal.json'),
  'eu/recepcion': () => import('../../../shared/i18n/eu/recepcion.json'),
  'eu/sala': () => import('../../../shared/i18n/eu/sala.json'),
  'eu/superadmin': () => import('../../../shared/i18n/eu/superadmin.json'),
  'eu/vocabulario': () => import('../../../shared/i18n/eu/vocabulario.json'),
  'fr/agenda': () => import('../../../shared/i18n/fr/agenda.json'),
  'fr/ajustes': () => import('../../../shared/i18n/fr/ajustes.json'),
  'fr/almacen': () => import('../../../shared/i18n/fr/almacen.json'),
  'fr/catalogos': () => import('../../../shared/i18n/fr/catalogos.json'),
  'fr/clinica': () => import('../../../shared/i18n/fr/clinica.json'),
  'fr/comun': () => import('../../../shared/i18n/fr/comun.json'),
  'fr/comunicacion': () => import('../../../shared/i18n/fr/comunicacion.json'),
  'fr/cuenta': () => import('../../../shared/i18n/fr/cuenta.json'),
  'fr/dinero': () => import('../../../shared/i18n/fr/dinero.json'),
  'fr/equipo': () => import('../../../shared/i18n/fr/equipo.json'),
  'fr/informes': () => import('../../../shared/i18n/fr/informes.json'),
  'fr/inicio': () => import('../../../shared/i18n/fr/inicio.json'),
  'fr/mantenimiento': () => import('../../../shared/i18n/fr/mantenimiento.json'),
  'fr/migracion': () => import('../../../shared/i18n/fr/migracion.json'),
  'fr/nube': () => import('../../../shared/i18n/fr/nube.json'),
  'fr/paciente': () => import('../../../shared/i18n/fr/paciente.json'),
  'fr/personal': () => import('../../../shared/i18n/fr/personal.json'),
  'fr/recepcion': () => import('../../../shared/i18n/fr/recepcion.json'),
  'fr/sala': () => import('../../../shared/i18n/fr/sala.json'),
  'fr/superadmin': () => import('../../../shared/i18n/fr/superadmin.json'),
  'fr/vocabulario': () => import('../../../shared/i18n/fr/vocabulario.json'),
  'gl/agenda': () => import('../../../shared/i18n/gl/agenda.json'),
  'gl/ajustes': () => import('../../../shared/i18n/gl/ajustes.json'),
  'gl/almacen': () => import('../../../shared/i18n/gl/almacen.json'),
  'gl/catalogos': () => import('../../../shared/i18n/gl/catalogos.json'),
  'gl/clinica': () => import('../../../shared/i18n/gl/clinica.json'),
  'gl/comun': () => import('../../../shared/i18n/gl/comun.json'),
  'gl/comunicacion': () => import('../../../shared/i18n/gl/comunicacion.json'),
  'gl/cuenta': () => import('../../../shared/i18n/gl/cuenta.json'),
  'gl/dinero': () => import('../../../shared/i18n/gl/dinero.json'),
  'gl/equipo': () => import('../../../shared/i18n/gl/equipo.json'),
  'gl/informes': () => import('../../../shared/i18n/gl/informes.json'),
  'gl/inicio': () => import('../../../shared/i18n/gl/inicio.json'),
  'gl/mantenimiento': () => import('../../../shared/i18n/gl/mantenimiento.json'),
  'gl/migracion': () => import('../../../shared/i18n/gl/migracion.json'),
  'gl/nube': () => import('../../../shared/i18n/gl/nube.json'),
  'gl/paciente': () => import('../../../shared/i18n/gl/paciente.json'),
  'gl/personal': () => import('../../../shared/i18n/gl/personal.json'),
  'gl/recepcion': () => import('../../../shared/i18n/gl/recepcion.json'),
  'gl/sala': () => import('../../../shared/i18n/gl/sala.json'),
  'gl/superadmin': () => import('../../../shared/i18n/gl/superadmin.json'),
  'gl/vocabulario': () => import('../../../shared/i18n/gl/vocabulario.json'),
  'it/agenda': () => import('../../../shared/i18n/it/agenda.json'),
  'it/ajustes': () => import('../../../shared/i18n/it/ajustes.json'),
  'it/almacen': () => import('../../../shared/i18n/it/almacen.json'),
  'it/catalogos': () => import('../../../shared/i18n/it/catalogos.json'),
  'it/clinica': () => import('../../../shared/i18n/it/clinica.json'),
  'it/comun': () => import('../../../shared/i18n/it/comun.json'),
  'it/comunicacion': () => import('../../../shared/i18n/it/comunicacion.json'),
  'it/cuenta': () => import('../../../shared/i18n/it/cuenta.json'),
  'it/dinero': () => import('../../../shared/i18n/it/dinero.json'),
  'it/equipo': () => import('../../../shared/i18n/it/equipo.json'),
  'it/informes': () => import('../../../shared/i18n/it/informes.json'),
  'it/inicio': () => import('../../../shared/i18n/it/inicio.json'),
  'it/mantenimiento': () => import('../../../shared/i18n/it/mantenimiento.json'),
  'it/migracion': () => import('../../../shared/i18n/it/migracion.json'),
  'it/nube': () => import('../../../shared/i18n/it/nube.json'),
  'it/paciente': () => import('../../../shared/i18n/it/paciente.json'),
  'it/personal': () => import('../../../shared/i18n/it/personal.json'),
  'it/recepcion': () => import('../../../shared/i18n/it/recepcion.json'),
  'it/sala': () => import('../../../shared/i18n/it/sala.json'),
  'it/superadmin': () => import('../../../shared/i18n/it/superadmin.json'),
  'it/vocabulario': () => import('../../../shared/i18n/it/vocabulario.json'),
  'nl/agenda': () => import('../../../shared/i18n/nl/agenda.json'),
  'nl/ajustes': () => import('../../../shared/i18n/nl/ajustes.json'),
  'nl/almacen': () => import('../../../shared/i18n/nl/almacen.json'),
  'nl/catalogos': () => import('../../../shared/i18n/nl/catalogos.json'),
  'nl/clinica': () => import('../../../shared/i18n/nl/clinica.json'),
  'nl/comun': () => import('../../../shared/i18n/nl/comun.json'),
  'nl/comunicacion': () => import('../../../shared/i18n/nl/comunicacion.json'),
  'nl/cuenta': () => import('../../../shared/i18n/nl/cuenta.json'),
  'nl/dinero': () => import('../../../shared/i18n/nl/dinero.json'),
  'nl/equipo': () => import('../../../shared/i18n/nl/equipo.json'),
  'nl/informes': () => import('../../../shared/i18n/nl/informes.json'),
  'nl/inicio': () => import('../../../shared/i18n/nl/inicio.json'),
  'nl/mantenimiento': () => import('../../../shared/i18n/nl/mantenimiento.json'),
  'nl/migracion': () => import('../../../shared/i18n/nl/migracion.json'),
  'nl/nube': () => import('../../../shared/i18n/nl/nube.json'),
  'nl/paciente': () => import('../../../shared/i18n/nl/paciente.json'),
  'nl/personal': () => import('../../../shared/i18n/nl/personal.json'),
  'nl/recepcion': () => import('../../../shared/i18n/nl/recepcion.json'),
  'nl/sala': () => import('../../../shared/i18n/nl/sala.json'),
  'nl/superadmin': () => import('../../../shared/i18n/nl/superadmin.json'),
  'nl/vocabulario': () => import('../../../shared/i18n/nl/vocabulario.json'),
  'pt/agenda': () => import('../../../shared/i18n/pt/agenda.json'),
  'pt/ajustes': () => import('../../../shared/i18n/pt/ajustes.json'),
  'pt/almacen': () => import('../../../shared/i18n/pt/almacen.json'),
  'pt/catalogos': () => import('../../../shared/i18n/pt/catalogos.json'),
  'pt/clinica': () => import('../../../shared/i18n/pt/clinica.json'),
  'pt/comun': () => import('../../../shared/i18n/pt/comun.json'),
  'pt/comunicacion': () => import('../../../shared/i18n/pt/comunicacion.json'),
  'pt/cuenta': () => import('../../../shared/i18n/pt/cuenta.json'),
  'pt/dinero': () => import('../../../shared/i18n/pt/dinero.json'),
  'pt/equipo': () => import('../../../shared/i18n/pt/equipo.json'),
  'pt/informes': () => import('../../../shared/i18n/pt/informes.json'),
  'pt/inicio': () => import('../../../shared/i18n/pt/inicio.json'),
  'pt/mantenimiento': () => import('../../../shared/i18n/pt/mantenimiento.json'),
  'pt/migracion': () => import('../../../shared/i18n/pt/migracion.json'),
  'pt/nube': () => import('../../../shared/i18n/pt/nube.json'),
  'pt/paciente': () => import('../../../shared/i18n/pt/paciente.json'),
  'pt/personal': () => import('../../../shared/i18n/pt/personal.json'),
  'pt/recepcion': () => import('../../../shared/i18n/pt/recepcion.json'),
  'pt/sala': () => import('../../../shared/i18n/pt/sala.json'),
  'pt/superadmin': () => import('../../../shared/i18n/pt/superadmin.json'),
  'pt/vocabulario': () => import('../../../shared/i18n/pt/vocabulario.json'),
  'ro/agenda': () => import('../../../shared/i18n/ro/agenda.json'),
  'ro/ajustes': () => import('../../../shared/i18n/ro/ajustes.json'),
  'ro/almacen': () => import('../../../shared/i18n/ro/almacen.json'),
  'ro/catalogos': () => import('../../../shared/i18n/ro/catalogos.json'),
  'ro/clinica': () => import('../../../shared/i18n/ro/clinica.json'),
  'ro/comun': () => import('../../../shared/i18n/ro/comun.json'),
  'ro/comunicacion': () => import('../../../shared/i18n/ro/comunicacion.json'),
  'ro/cuenta': () => import('../../../shared/i18n/ro/cuenta.json'),
  'ro/dinero': () => import('../../../shared/i18n/ro/dinero.json'),
  'ro/equipo': () => import('../../../shared/i18n/ro/equipo.json'),
  'ro/informes': () => import('../../../shared/i18n/ro/informes.json'),
  'ro/inicio': () => import('../../../shared/i18n/ro/inicio.json'),
  'ro/mantenimiento': () => import('../../../shared/i18n/ro/mantenimiento.json'),
  'ro/migracion': () => import('../../../shared/i18n/ro/migracion.json'),
  'ro/nube': () => import('../../../shared/i18n/ro/nube.json'),
  'ro/paciente': () => import('../../../shared/i18n/ro/paciente.json'),
  'ro/personal': () => import('../../../shared/i18n/ro/personal.json'),
  'ro/recepcion': () => import('../../../shared/i18n/ro/recepcion.json'),
  'ro/sala': () => import('../../../shared/i18n/ro/sala.json'),
  'ro/superadmin': () => import('../../../shared/i18n/ro/superadmin.json'),
  'ro/vocabulario': () => import('../../../shared/i18n/ro/vocabulario.json'),
  'ru/agenda': () => import('../../../shared/i18n/ru/agenda.json'),
  'ru/ajustes': () => import('../../../shared/i18n/ru/ajustes.json'),
  'ru/almacen': () => import('../../../shared/i18n/ru/almacen.json'),
  'ru/catalogos': () => import('../../../shared/i18n/ru/catalogos.json'),
  'ru/clinica': () => import('../../../shared/i18n/ru/clinica.json'),
  'ru/comun': () => import('../../../shared/i18n/ru/comun.json'),
  'ru/comunicacion': () => import('../../../shared/i18n/ru/comunicacion.json'),
  'ru/cuenta': () => import('../../../shared/i18n/ru/cuenta.json'),
  'ru/dinero': () => import('../../../shared/i18n/ru/dinero.json'),
  'ru/equipo': () => import('../../../shared/i18n/ru/equipo.json'),
  'ru/informes': () => import('../../../shared/i18n/ru/informes.json'),
  'ru/inicio': () => import('../../../shared/i18n/ru/inicio.json'),
  'ru/mantenimiento': () => import('../../../shared/i18n/ru/mantenimiento.json'),
  'ru/migracion': () => import('../../../shared/i18n/ru/migracion.json'),
  'ru/nube': () => import('../../../shared/i18n/ru/nube.json'),
  'ru/paciente': () => import('../../../shared/i18n/ru/paciente.json'),
  'ru/personal': () => import('../../../shared/i18n/ru/personal.json'),
  'ru/recepcion': () => import('../../../shared/i18n/ru/recepcion.json'),
  'ru/sala': () => import('../../../shared/i18n/ru/sala.json'),
  'ru/superadmin': () => import('../../../shared/i18n/ru/superadmin.json'),
  'ru/vocabulario': () => import('../../../shared/i18n/ru/vocabulario.json'),
  'uk/agenda': () => import('../../../shared/i18n/uk/agenda.json'),
  'uk/ajustes': () => import('../../../shared/i18n/uk/ajustes.json'),
  'uk/almacen': () => import('../../../shared/i18n/uk/almacen.json'),
  'uk/catalogos': () => import('../../../shared/i18n/uk/catalogos.json'),
  'uk/clinica': () => import('../../../shared/i18n/uk/clinica.json'),
  'uk/comun': () => import('../../../shared/i18n/uk/comun.json'),
  'uk/comunicacion': () => import('../../../shared/i18n/uk/comunicacion.json'),
  'uk/cuenta': () => import('../../../shared/i18n/uk/cuenta.json'),
  'uk/dinero': () => import('../../../shared/i18n/uk/dinero.json'),
  'uk/equipo': () => import('../../../shared/i18n/uk/equipo.json'),
  'uk/informes': () => import('../../../shared/i18n/uk/informes.json'),
  'uk/inicio': () => import('../../../shared/i18n/uk/inicio.json'),
  'uk/mantenimiento': () => import('../../../shared/i18n/uk/mantenimiento.json'),
  'uk/migracion': () => import('../../../shared/i18n/uk/migracion.json'),
  'uk/nube': () => import('../../../shared/i18n/uk/nube.json'),
  'uk/paciente': () => import('../../../shared/i18n/uk/paciente.json'),
  'uk/personal': () => import('../../../shared/i18n/uk/personal.json'),
  'uk/recepcion': () => import('../../../shared/i18n/uk/recepcion.json'),
  'uk/sala': () => import('../../../shared/i18n/uk/sala.json'),
  'uk/superadmin': () => import('../../../shared/i18n/uk/superadmin.json'),
  'uk/vocabulario': () => import('../../../shared/i18n/uk/vocabulario.json'),
}
